import { Address } from '@ravago/shared/page-data/models/elements/address.model';
import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { Radio } from '@ravago/shared/radiance/components/radio/components/Radio/Radio';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   address: Address;
}

export const RfqAddressPicker = ({ address }: Props) => {
   const translate = useTranslations();

   return (
      <Radio id={`customer-delivery-address-${address.id}`} value={address}>
         {address.isDefault && (
            <Badge variant="info">
               <Typography component="p" variant="small" color="inherit">
                  {translate('page-consumer.request-for-quotation.default')}
               </Typography>
            </Badge>
         )}
         <Typography component="b" variant="body" color="strong">
            {`${address.line1}, ${address.line2}`}
         </Typography>
         <Typography component="p" variant="body" color="strong">
            {`${address.city}, ${address.postCode} - ${address.countryName}`}
         </Typography>
      </Radio>
   );
};
